import { render } from "./ChatImpulse.vue?vue&type=template&id=581059a5"
import script from "./ChatImpulse.vue?vue&type=script&lang=js"
export * from "./ChatImpulse.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__